<template>
	<div class="nav active-users" :mode="activeMode">
		<div class="active-users__preview" @click="onListToggle">
			<div
				class="active-users__preview-profiles"
				ref="previewUserImgsRef"
			>
				<ProfileImage
					class="active-users__preview-profiles-item"
					v-for="user in visibleConcurrentUsers"
					:key="user.EmployeeId"
					:imageSrc="user.EmployeeImage"
					:firstName="user.FirstName"
					:lastName="user.LastName"
				/>
			</div>

			<Badge
				class="active-users__preview-count-badge"
				:text="'+' + hiddenUserCount"
				:visible="hiddenUserCount > 0"
			>
			</Badge>

			<span
				class="active-users__preview-count-text"
				v-if="hiddenUserCount > 0"
				>Active Users</span
			>
		</div>
		<!-- This zIndex value corresponds with $z-level1-5: 2500; -->
		<Popover
			:visible="listVisible"
			trackedRefName="previewUserImgsRef"
			:zIndex="2500"
			:offset="[0, 16]"
			placement="bottom"
			@close="onCloseList"
		>
			<template v-slot:popoverBody>
				<div class="active-users__total-users">
					{{ activeUserCount }} Active Users
				</div>

				<ul class="active-users__total-users-list">
					<li
						class="active-users__total-users-list-item"
						v-for="user in groupConcurrentUsers"
						:key="user.EmployeeId"
					>
						<ProfileImage
							:imageSrc="user.EmployeeImage"
							:height="50"
							:firstName="user.FirstName"
							:lastName="user.LastName"
						/>

						<span class="active-users__total-users-list-item-name">
							{{ nameFromArray(user.FirstName) }}
							{{ nameFromArray(user.LastName) }}
						</span>

						<template v-if="user.locked">
							<i
								class="active-users__locked-user icon icon-key"
								@mouse-over="showTooltip = true"
								@mouse-leave="showTooltip = false"
							/>
							<Tooltip v-if="showTooltip">
								{{ nameFromArray(user.FirstName) }}
								{{ nameFromArray(user.LastName) }} is currently
								editing the page. }.
							</Tooltip>
						</template>
					</li>
				</ul>
			</template>
		</Popover>
	</div>
</template>

<!-- DEV NOTE: js changes are for test purposes, feel free to make any update. -->

<script>
import { mapGetters } from 'vuex';
import ProfileImage from '@/components/visual/image/profile-image.vue';
import Popover from '@/components/shells/popover/popover.vue';
import Badge from '@/components/shells/badge/badge.vue';

export default {
	name: 'ConcurrentUsers',
	data() {
		return {
			activeMode: 'light',
			listVisible: false,
			showTooltip: false
		};
	},
	props: {
		displayImageCount: {
			type: Number,
			default: 4
		}
	},
	components: {
		ProfileImage,
		Popover,
		Badge
	},
	computed: {
		...mapGetters('communicationHub', [
			'concurrentUsersByGroup',
			'displayConcurrentUsers',
			'groupLockEnabled',
			'groupName'
		]),
		groupConcurrentUsers() {
			return this.concurrentUsersByGroup(this.groupName);
		},
		show() {
			return this.displayConcurrentUsers;
		},
		visibleConcurrentUsers() {
			//users that will always show above the popover
			let users;

			if (
				this.groupConcurrentUsers &&
				this.groupConcurrentUsers.length > this.displayImageCount
			) {
				users = this.groupConcurrentUsers.slice(
					0,
					this.displayImageCount
				);
			} else {
				users = this.groupConcurrentUsers;
			}

			return users;
		},
		activeUserCount() {
			let count = 0;

			if (this.groupConcurrentUsers) {
				count = this.groupConcurrentUsers.length;
			}

			return count;
		},
		hiddenUserCount() {
			let count = 0;

			if (this.groupConcurrentUsers) {
				count =
					this.groupConcurrentUsers.length - this.displayImageCount;
			}

			return count;
		}
	},
	methods: {
		onListToggle() {
			this.listVisible = !this.listVisible;
		},
		nameFromArray(name) {
			//the user's name's may be an array of names that come from Employee and Global Employee
			if (Array.isArray(name) && name.length > 0) {
				name = name[0];
			}

			return name;
		},
		onCloseList() {
			this.listVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.active-users {
	/* To test it in the  Project uncomment the below styles */

	position: absolute;
	right: 0;
	top: 48px;
	padding: $padding-sm;
	z-index: $z-level3;

	&__locked-user {
		margin-left: $gutter-md;
	}

	&__preview {
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;

		&-count-badge {
			padding: 0;
			margin-left: -9px;
			&:deep(.badge__pill) {
				height: 24px;
				width: 24px;
				max-width: 24px;
				border-radius: 50%;
			}
		}

		&-count-text {
			margin-left: $gutter-sm;
		}
	}

	&__preview-profiles {
		display: flex;
		flex-direction: row;
	}

	&__preview-profiles-item {
		&:not(:first-child) {
			margin-left: -9px;
		}
	}

	&__total-users {
		@include heading('sm');
		cursor: default;
		white-space: nowrap;
	}

	&__total-users-list {
		cursor: default;

		&-item {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-top: $gutter-md;
			white-space: nowrap;
		}

		&-item-name {
			margin-left: $gutter-md;
			font-size: $heading-font-size-sm;
		}
	}
}
</style>
